import type { ClassValue } from 'clsx'
import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { Position } from '@/types/chatbot-types'
import { WIDGET_CONSTANTS } from '@/types/constants'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getPositionClass(position?: Position): string {
  if (!position) {
    return `widget-position-${WIDGET_CONSTANTS.DEFAULT_POSITION}`
  }

  const cssPosition =
    WIDGET_CONSTANTS.POSITION_MAPPING[
      position as keyof typeof WIDGET_CONSTANTS.POSITION_MAPPING
    ] || WIDGET_CONSTANTS.DEFAULT_POSITION
  return `widget-position-${cssPosition}`
}
